var show_subit_butto_wizard_availability = true;
var show_subit_butto_wizard_checktotal = true;

var frontend = function () {

    var frontend = this;

    this.bindDetailEvents = function (locale, school) {
        var price = function (idChildProduct, forcedDate) {
            // recupero la data
            var date = forcedDate;

            if (!date) {
                if (parseInt($("#multiple_dates").val())) {
                    date = $(".product-dates[data-first=1]").val();
                } else {
                    date = $("#product-date").val();
                }
            }

            var idProduct = $("#id_product").val();

            // nascondo il div dei prezzi
            $("#product-price").hide();

            if ($.trim(date) !== 'undefined') {
                // mostro il loader
                $(".spinner").show();

                // faccio una chiamata ajax che mi tornerà una form da inserire in #product-price
                $.get(siteUrl + "/product/" + idProduct + "/price", {date: date})
                    .done(function (data) {
                        $("#product-price").html(data);
                        $(".spinner").hide();
                        $("#product-price").show();

                        frontend.check_availability(idChildProduct ?? idProduct, date, frontend.getTotaleNumber());
                    })
                    .fail(function (data) {
                        $("#product-price").html('<h2 class="text-center">' + data.responseJSON.message + '</h2>');
                        $(".spinner").hide();
                        $("#product-price").show();
                    });
            }
        };

        var minDate = $("#min_date").val();
        var maxDate = $("#max_date").val();
        var dates = JSON.parse($("#dates").val());

        $("#product-date").datetimepicker({
            locale    : locale,
            minDate: minDate,
            maxDate: maxDate,
            // enabledDates : dates,
            format    : 'DD/MM/YYYY',
            useCurrent: false
        });

        $(".product-dates").datetimepicker({
            locale    : locale,
            minDate: minDate,
            maxDate: maxDate,
            // enabledDates : dates,
            format    : 'DD/MM/YYYY',
            useCurrent: false
        });

        $("#product-date").on('dp.change', function (e) {
            price();
        });

        $(".product-dates").on('dp.change', function (e) {
            price(parseInt($(this).attr('data-id-product')), $(this).val());
        });

        price();

        $('.slick').slick({
            variableWidth: true
        });
    };

    this.getTotaleNumber  = function () {
        var total = 0;
        $( ".ct_nr" ).each(function( index ) {
            total = total + parseInt($( this ).val());
        });

        return total;
    };

    this.check_availability = function (idProduct, date, now_used) {
        // recupero la data
        $.get(siteUrl + "/product/" + idProduct + "/get_availability", {date: date, now_used: now_used})
            .done(function (data) {

                if ($("#multiple_dates").val()) {
                    var product_prime_submit = true;
                    $.each(data, function(id_location, item) {
                        $(`.color_marker_available[data-id-product=${id_location}]`).css({"color": `${item.message}`});
                        $(`.availability-message[data-id-product=${id_location}]`).css({"color": `${item.message}`});
                        $(`.availability-message[data-id-product=${id_location}]`).html(item.text_message);
                        if (item.show_message) {
                            $("#div_sold_out").show();
                            $(`.availability-message[data-id-product=${id_location}]`).show();
                        } else {
                            $("#div_sold_out").hide();
                            $(`.availability-message[data-id-product=${id_location}]`).hide();
                        }
                        if (!item.response) {
                           // console.log("trovato false");
                            product_prime_submit = false;
                        }

                    });

                    if (product_prime_submit && show_subit_butto_wizard_checktotal) {
                        //console.log("mostra");
                        $(".product-price-submit").show();
                    } else {
                        //console.log("nascondi");
                        $(".product-price-submit").hide();
                    }

                    show_subit_butto_wizard_availability = product_prime_submit;
                    //console.log(show_subit_butto_wizard_availability);
                }
            })
            .fail(function (data) {
                $(".product-price-submit").hide();
            });

    };

    this.bindPriceBoxEvents = function () {
        $('.ct_nr').change(function (e) {
            if (parseInt($("#multiple_dates").val())) {
                $(".product-dates").each(function () {
                    var date = $(this).val();
                    var idProduct = $(this).attr('data-id-product');

                    frontend.check_availability(idProduct, date, frontend.getTotaleNumber());
                });

            } else {
                var date = $("#product-date").val();
                var idProduct = $("#id_product").val();

                frontend.check_availability(idProduct, date, frontend.getTotaleNumber());
            }
        });

        $('.btn-number').click(function (e) {
            e.preventDefault();

            var fieldName  = $(this).attr('data-field');
            var type       = $(this).attr('data-type');
            var input      = $("input[name='" + fieldName + "']");
            var currentVal = parseInt(input.val());
            if (!isNaN(currentVal)) {
                if (type === 'minus' && currentVal !== 0) {
                    input.val(currentVal - 1).change();
                    if (parseInt(input.val()) === 0) {
                        $(this).attr('disabled', true);
                    }

                } else if (type === 'plus') {
                    input.val(currentVal + 1).change();
                }
            } else {
                input.val(0);
            }
        });
        $('.input-number').focusin(function () {
            $(this).data('oldValue', $(this).val());
        });
        $(".input-number").keydown(function (e) {
            // Allow: backspace, delete, tab, escape, enter and .
            if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 190]) !== -1 ||
                // Allow: Ctrl+A
                (e.keyCode == 65 && e.ctrlKey === true) ||
                // Allow: home, end, left, right
                (e.keyCode >= 35 && e.keyCode <= 39)) {
                // let it happen, don't do anything
                return;
            }
            // Ensure that it is a number and stop the keypress
            if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
                e.preventDefault();
            }
        });
    };

    this.bindCancelButton = function () {
        $(".product-price-button.back").unbind("click").bind("click", function () {
            return confirm($(this).attr('data-label'));
        });
    };

    this.bindPriceEvents = function () {
        this.bindPriceBoxEvents();

        this.bindCancelButton();

        $('.product-price').find('.input-number').change(function () {

            var minValue     = 0;
            var valueCurrent = parseInt($(this).val());
            var handicap = $(this).attr('data-handicap');

            if (handicap) {
                // se ho almeno un handicap sblocco gli accompagnatori
                let unlock = false;
                $('[data-handicap=1]').each(function () {
                    if (parseInt($(this).val()) > 0)
                        unlock = true;
                });

                if (unlock) {
                    // abilitare data-companion=1
                    $('[data-companion=1]').prop('disabled', false);
                } else {
                    // disabilitare data-companion=1
                    $('[data-companion=1]').prop('disabled', true);
                    $('input[data-companion=1]').val(0);
                }
            }

            var name = $(this).attr('name');
            if (valueCurrent >= minValue) {
                $(".btn-number[data-type='minus'][data-field='" + name + "']").removeAttr('disabled')
            } else {
                alert($(this).closest('.price-box').attr('data-warn'));
                $(this).val($(this).data('oldValue'));
            }

            frontend.updateTotalPrice();
        });

        $('.product-price-handicap').on('change', function () {
            if ($(this).is(':checked')) {
                $('.price-box.handicap').removeClass('hidden');
            } else {
                $('.price-box.handicap').find('.input-number').val(0);
                $('.price-box.handicap').addClass('hidden');
                frontend.updateTotalPrice();
            }
        });

        frontend.updateTotalPrice();
    };

    this.updateTotalPrice = function () {
        this.bindCancelButton();

        var idProduct = $("#id_product").val();
        // recupero le informazioni che ho all'interno della form
        var data      = new FormData($('.product-price')[0]);
        data.append('total', true);

        var dates = [];
        $(".product-dates").each(function () {
            dates.push({
                id_product: $(this).attr('data-id-product'),
                product_label: $(this).attr('data-product-label'),
                date: $(this).val()
            });
        });
        data.append('dates', JSON.stringify(dates));

        $.ajax({
            url        : siteUrl + '/product/' + idProduct + '/session',
            data       : data,
            processData: false,
            contentType: false,
            type       : 'post'
        })
            .done(function (data) {

                if (typeof data.price != "undefined") {
                    var price_array = data.price;
                    var tmp_price = "";
                    $.each(price_array, function (i, product_price_array) {
                        $.each(product_price_array, function (j, price_ct) {
                            $.each(price_ct, function (price_key, price_val) {
                                tmp_price = $("#price_"+i+"_"+price_key).html();
                                if (tmp_price != price_val)
                                    $("#price_"+i+"_"+price_key).html(price_val);
                            });

                        });
                    });
                }

                var total = parseFloat(data.total);
                var packageTotal = parseFloat(data.package_total);

                if (data.handicap && total < 0)
                    total = 0;

                if (total >= 0) {
                    $('.product-price-total:not(.automatic)').html(total.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,") + "€");
                    if (data.automatic && packageTotal >= 0) {
                        $('.product-price-total.automatic').html(packageTotal.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,") + "€");
                        $('.automatic').show();
                    }

                    var discount = data.discount;
                    if (discount.count !== 0 ) {
                        // ho degli sconti per cui li mostro assieme agli importi
                        $('.product-price-discount').removeClass('text-center');
                        $('.product-price-discount').html('<h3 class="text-center text-uppercase" style="margin-bottom: 10px; margin-top: 10px;">' + $('.product-price-discount').attr('data-title') + '</h3>');
                        $.each(discount.amounts, function () {
                            var amount = parseFloat(this.amount).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,") + "€";
                            var label = this.label;
                            if (typeof this.count !== 'undefined') {
                                label += ' x' + this.count;
                            }
                            $('.product-price-discount').append('<div class="row"><div class="col-xs-9">' + label + '</div><div class="col-xs-3 text-right">-' + amount + '</div></div>');
                        });
                    } else {
                        $('.product-price-discount').html("");
                    }

                    var tax = data.tax;
                    if (tax.length > 0) {
                        // ho delle tasse da mostrare
                        $('.product-price-tax').html('<h3 class="text-center text-uppercase" style="margin-bottom: 10px; margin-top: 10px;">' + $('.product-price-tax').attr('data-title') + '</h3>');
                        $.each(tax, function () {
                            var amount = parseFloat(this.amount).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,") + "€";
                            var label = this.label;
                            if (typeof this.count !== 'undefined') {
                                label += ' x' + this.count;
                            }
                            $('.product-price-tax').append('<div class="row"><div class="col-xs-9">' + label + '</div><div class="col-xs-3 text-right">' + amount + '</div></div>');
                        });
                    } else {
                        $('.product-price-tax').html("");
                    }
                } else {
                    $('.product-price-total').html($('.product-price-total').attr('data-invalid'));
                    $('.product-price-discount').addClass('text-center');
                    var error = typeof data.error !== 'undefined' ? data.error : $('.product-price-discount').attr('data-empty');
                    $('.product-price-discount').html(error);
                    $('.automatic').hide();
                }
                //console.log(show_subit_butto_wizard_availability);
                if (total > 0 || data.handicap) {
                    show_subit_butto_wizard_checktotal = true;
                    if (show_subit_butto_wizard_availability) {
                        //console.log("mostra3");
                        $('.product-price-submit').show();
                    }
                } else {
                    show_subit_butto_wizard_checktotal = false;
                    if (!show_subit_butto_wizard_availability)
                        $('.product-price-submit').hide();
                }
            })
            .fail(function (data) {
                // TODO
            });

        $(".product-price-submit").click(function (e) {
            // controllo che tutti i tour se abbiano un numero diverso da 0, abbiano anche uno slot
            var redirect = true;
            var unlock = $(this).attr("data-unlock");
            $('.extra').find('.extra-tour').each(function () {
                if (parseInt($(this).find('[data-interaction=equal]').attr('data-toggle')) === 0) {
                    return;
                }

                if (parseInt($(this).find('[data-interaction=webooking-code]').attr('code-checked')) === 1) {
                    return;
                }

                var number = parseInt($(this).find(".tour-number").val());
                var slotSelected = $(this).find('.slots-detail').find('.selected').length > 0;

                if (number > 0 && !slotSelected) {
                    // ho selezionato un numero di persone ma poi non ho portato a termine la prenotazione della visita guidata
                    redirect = false;
                }
            });

            if (!redirect) {
                e.preventDefault();

                // TODO: cambiare testo, metterlo in lingua e chiedere a Barb cosa mettere e come visualizzarlo
                alert("Devi completare la scelta dello slot per le visite guidate");
                return;
            }

            if (typeof unlock !== 'undefined' && unlock) {
                if (!confirm("Si è sicuri di voler confermare?")) {
                    e.preventDefault();
                }
            }
        });


    };

    this.bindExtraEvents = function () {
        this.bindPriceBoxEvents();

        $('.extra').find('.extra-box:not(.extra-tour)').find('.input-number').unbind('change').bind('change', function () {
            var minValue     = 0;
            var valueCurrent = parseInt($(this).val());
            var name = $(this).attr('name');

            if (valueCurrent >= minValue) {
                $(".btn-number[data-type='minus'][data-field='" + name + "']").removeAttr('disabled')
            } else {
                alert($(this).closest('.price-box').attr('data-warn'));
                $(this).val($(this).data('oldValue'));
            }

            frontend.updateTotalExtra();
        });

        $('[data-interaction=equal]').unbind('click').bind('click', function () {
            var group = $(this).attr('data-group');
            var classes = $(this).find("i").attr("class");
            var label = $(this).find("span").html();
            var id = $(this).closest(".extra-box").find(".tour-id").val();
            var self = this;
            var idProduct = $("#id_product").val();
            var type = $(this).attr('data-type');

            $(this).find("i").attr("class", $(this).attr("data-toggle-icon"));
            $(this).find("span").html($(this).attr("data-toggle-label"));

            $(this).attr("data-toggle-icon", classes);
            $(this).attr("data-toggle-label", label);

            if (parseInt($(this).attr("data-toggle")) === 0) {
                // aggiungo
                $(this).attr("data-toggle", "1");
                $(this).css("border", "1px solid #c10909");

                $(this).closest(".extra-content").find(".price-box").show();

                $('[data-group=' + group + ']').each(function () {
                    $(this).val($(this).attr('data-n'));
                });

                $('[data-group=' + group + ']').trigger('change');
            } else {
                // elimino
                $(this).closest('.extra-tour').find('.tour-detail').html($(".spinner").clone());
                $(this).closest('.extra-tour').find('.tour-detail').find(".spinner").show();

                $.post(siteUrl + '/product/' + idProduct + '/session', {
                    is_tour: type === 'tour',
                    action: 'remove',
                    id: id
                }).done(function (data) {
                    $("#product-price").html(data);

                    $(self).attr("data-toggle", "0");
                    $(self).css("border", "1px solid #57c16e");
                    $(self).closest('.extra-tour').find('.tour-detail').html("");

                    $(self).closest(".extra-box").find(".price-box").hide();
                    $(self).closest(".extra-box").find(".actions").hide();
                    $(self).closest(".extra-tour").find(".tour-detail").hide();

                    $(".product-date-price").find(".spinner").hide();
                }).fail(function () {
                    $(self).closest('.extra-tour').find('.tour-detail').html("");

                    $(".product-date-price").find(".spinner").hide();
                });
            }
        });

        let automatic = parseInt($("#automatic").val()) === 1;
        let idProduct = $("#id_product").val();
        $("select.theme").on("change", function () {
            if (automatic) {
                let id = $(this).closest('.extra-tour').find(".tour-id").val();

                $(".product-date-price").find(".spinner").show();

                $.post(siteUrl + '/product/' + idProduct + '/session', {
                    is_tour: true,
                    action: 'theme',
                    id: id,
                    id_theme: $(this).val()
                }).done(function (data) {
                    $("#product-price").html(data);
                    $(".product-date-price").find(".spinner").hide();
                });
            }
        });

        frontend.updateTotalExtra();
    };

    this.updateTotalExtra = function () {
        // recupero l'id del prodotto
        var idProduct = $("#id_product").val();
        // recupero le informazioni che ho all'interno della form
        var data      = new FormData($('.product-extra')[0]);

        $(".spinner").show();
        $.ajax({
            url        : siteUrl + '/product/' + idProduct + '/session',
            data       : data,
            processData: false,
            contentType: false,
            type       : 'post'
        })
            .done(function (data) {
                $("#product-price").html(data);
                $(".spinner").hide();
            })
            .fail(function (data) {
                $("#product-price").html('<h2 class="text-center">' + data.responseJSON.message + '</h2>');
                $(".spinner").hide();
            });
    };

    this.bindTourEvents = function (locale) {
        // recupero l'id del prodotto
        var idProduct = $("#id_product").val();
        // recupero l'array dei giorni di disponibilità
        let days = $("#days").val();
        if ($.trim(days) === '')
            return;

        days = JSON.parse($("#days").val());

        if (Object.keys(days).length > 0) {
            $('.extra-tour').each(function () {
                var self = this;
                var location = $(this).find(".tour-location").val();

                $(this).find('.datetimepicker').datetimepicker({
                    locale: locale,
                    format    : 'DD/MM/YYYY',
                    useCurrent: false,
                    enabledDates: Object.keys(days[location])
                });

                var matrix = function () {
                    var date = $(self).find(".datetimepicker").val();
                    var number = $(self).find(".tour-number").val();
                    var id = $(self).find(".tour-id").val();

                    // TODO: validation

                    $(self).find('.tour-detail').html($(".spinner").clone());
                    $(self).find('.tour-detail').find(".spinner").show();
                    $(self).find('.tour-detail').show();
                    $.post(siteUrl + '/product/' + idProduct + '/session', {
                        is_tour: true,
                        action: 'remove',
                        id: id
                    }).done(function (data) {
                        $("#product-price").html(data);

                        $.post(siteUrl + "/product/" + idProduct + "/slots", {
                            id: id,
                            location: location,
                            date: date,
                            number: number
                        }).done(function (data) {
                            $(self).find('.tour-detail').html(data).show();
                        }).fail(function (data) {
                            $(self).find('.tour-detail').html('<h2 class="text-center">' + data.responseJSON.message + '</h2>').show();
                        });
                    });
                };

                $(this).find('.datetimepicker').on("dp.change", function () {
                    matrix();
                });

                if ($(this).find(".price-box").css("display") === "block")
                    $(this).find('.datetimepicker').trigger('dp.change');

                $(this).find('[data-interaction=check]').unbind('click').bind('click', function () {
                    matrix();
                });

                $(this).find('.theme').on('change', function () {
                    matrix();
                });
            });
        }

        $('.extra').find('.extra-tour').find('.input-number').unbind('change').bind('change', function () {
            var minValue     = 0;
            var valueCurrent = parseInt($(this).val());
            var name = $(this).attr('name');
            var id = $(this).closest('.extra-tour').find(".tour-id").val();
            var self = this;

            if (valueCurrent >= minValue) {
                $(".btn-number[data-type='minus'][data-field='" + name + "']").removeAttr('disabled')
            } else {
                $(this).val($(this).data('oldValue'));
            }

            $(".product-date-price").find(".spinner").show();

            $(this).closest('.extra-tour').find('.tour-detail').html($(".spinner").clone());
            $(this).closest('.extra-tour').find('.tour-detail').find(".spinner").show();

            $.post(siteUrl + '/product/' + idProduct + '/session', {
                is_tour: true,
                action: 'remove',
                id: id
            }).done(function (data) {
                $("#product-price").html(data);
                $(".product-date-price").find(".spinner").hide();

                // nascondo
                $(self).closest('.extra-tour').find('.tour-detail').html("");
                if (valueCurrent > 0) {
                    $(self).closest('.extra-tour').find('.actions').show();

                    if ($.trim($(self).closest('.extra-tour').find(".datetimepicker").val()) !== '') {
                        $(self).closest('.extra-tour').find('[data-interaction=check]').trigger('click');
                    }
                } else {
                    $(self).closest('.extra-tour').find('.actions').hide();
                }
            }).fail(function (data) {
                $(self).closest('.extra-tour').find('.tour-detail').html('<h2 class="text-center">' + data.responseJSON.message + '</h2>');

                $(self).closest('.extra-tour').find('.actions').hide();
                $(".product-date-price").find(".spinner").hide();
            });
        });
    };
};
